module.exports = __webpack_public_path__ + "img/bg-jion-doctor.50b95584.png";